import styled from 'styled-components';

export const InterviewFormWrapper = styled.div`
  display: flex;
`;

export const InfoElement = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
`;

export const InfoBlock = styled.div`
  margin-right: 48px;
`;
